import React from 'react';
import classnames from 'classnames';

import QuestionHOC from './QuestionHOC';

function Header({ item, index }) {
  const fontSize = classnames({
    '20px': item.fontSize === 'large',
    '18px': item.fontSize === 'medium',
    '16px': item.fontSize === 'small'
  });

  return <QuestionHOC item={item} index={index}>
    <p style={{ fontSize: fontSize, fontWeight: item.bold ? 'bold' : '' }} className="mt-3 mb-2">{item.text}</p>
  </QuestionHOC>
}


export default Header;